import { PermissionGuard } from '@/ui/components/permissionGuard/PermissionGuard';

import { LabourForecastPermissions } from '@payaca/permissions/labourForecast/labourForecast.permissions';
import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import { FC } from 'react';
import { LabourActualCard } from './LabourActualCard';
import { LabourForecastCard } from './LabourForecastCard';

export const LabourPanel: FC = () => {
  return (
    <div className="space-y-4 @container">
      <PermissionGuard
        renderIfHasPermissions={[LabourForecastPermissions.GET_LABOUR_FORECAST]}
      >
        <LabourForecastCard />
      </PermissionGuard>
      <PermissionGuard
        renderIfHasPermissions={[
          TimelogsPermissions.GET_SELF_ASSIGNED_TIMELOGS,
          TimelogsPermissions.GET_TIMELOGS,
        ]}
      >
        <LabourActualCard />
      </PermissionGuard>
    </div>
  );
};
